import React from "react";
import { defineMessages, FormattedNumber, FormattedDate } from "react-intl";
import Panel from "../Panel/Panel";
import DetailList, { DetailListItem } from "../../../../presentational/DetailList/DetailList";
import moment from "moment";
import styles from "./AccountSummary.module.less";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
import RouteTable from "../../Dashboard/AccountList/AccountCard/RouteTable/RouteTable";
const messages = defineMessages({
    header: {
        id: "account.accountSummary.header",
        defaultMessage: "Account Summary"
    },
    creditorLabel: {
        id: "account.accountSummary.creditor.label",
        defaultMessage: "Creditor"
    },
    accountNumberLabel: {
        id: "account.accountSummary.accountNumber.label",
        defaultMessage: "Account Number"
    },
    currentBalanceLabel: {
        id: "account.accountSummary.currentBalance.label",
        defaultMessage: "Current Balance"
    },
    settlementAgreementLabel: {
        id: "account.accountSummary.settlementAgreement.label",
        defaultMessage: "Settlement Agreement"
    },
    settlementOfferLabel: {
        id: "account.accountSummary.settlementOffer.label",
        defaultMessage: "Settlement Offer"
    },
    monthlyPaymentLabel: {
        id: "account.accountSummary.monthlyPayment.label",
        defaultMessage: "Monthly Payment"
    },
    paymentDueDateLabel: {
        id: "account.accountSummary.paymentDueDate.label",
        defaultMessage: "Payment Due Date"
    },
    nextPaymentDueDateLabel: {
        id: "account.accountSummary.nextPaymentDueDate.label",
        defaultMessage: "Next Payment Due Date"
    },
    totalBalanceLabel: {
        id: "account.accountSummary.totalBalance.label",
        defaultMessage: "Total Balance"
    }
});
const AccountSummary = (props) => {
    const singleAccount = props.routeGroup.accounts.length === 1;
    const acct = props.routeGroup.primary;
    const extraDetails = [];
    if (singleAccount && !acct.accountClosed) {
        if (acct.settlementAgreement != null && acct.settlementAgreement > 0) {
            extraDetails.push(<DetailListItem key="settlementAgreement" label={messages.settlementAgreementLabel}>
					<FormattedNumber value={acct.settlementAgreement} style="currency" currency="USD"/>
				</DetailListItem>);
        }
        if (acct.settlementOffer != null && acct.settlementOffer > 0) {
            extraDetails.push(<DetailListItem key="settlementOffer" label={messages.settlementOfferLabel}>
					<FormattedNumber value={acct.settlementOffer} style="currency" currency="USD"/>
				</DetailListItem>);
        }
        const showMonthlyPayment = acct.monthlyPayment != null && acct.monthlyPayment > 0;
        if (showMonthlyPayment) {
            extraDetails.push(<DetailListItem key="monthlyPayment" label={messages.monthlyPaymentLabel}>
					<FormattedNumber value={acct.monthlyPayment} style="currency" currency="USD"/>
				</DetailListItem>);
        }
        const paymentDueDate = acct.paymentDueDate == null ? null : moment(acct.paymentDueDate);
        if (paymentDueDate != null && !paymentDueDate.isBefore(moment().startOf("day"))) {
            extraDetails.push(<DetailListItem key="paymentDueDate" label={showMonthlyPayment ? messages.nextPaymentDueDateLabel : messages.paymentDueDateLabel}>
					<FormattedDate value={paymentDueDate.toDate()}/>
				</DetailListItem>);
        }
    }
    return (<Panel heading={messages.header}>
			{acct.notice != null && (<div className="vr vr_x5 text">
					<p>
						<i className="fa fa-exclamation-triangle" aria-hidden/>
						<span className="sr-only"> Notice</span>
						{" "}
						<span role="alert">
							{acct.notice}
						</span>
					</p>
				</div>)}

			<div className={styles.detailWrapper}>
				{singleAccount && (<DetailList className={styles.details}>
						{(process.env.CLIENT == null || acct.creditor != null) && (<DetailListItem label={messages.creditorLabel}>
								{acct.creditor}
							</DetailListItem>)}
						<DetailListItem label={messages.accountNumberLabel}>
							<AccountNumber value={acct.acctNum}/>
						</DetailListItem>
						{!acct.accountClosed && (<DetailListItem label={messages.currentBalanceLabel}>
								<FormattedNumber value={acct.balance} style="currency" currency="USD"/>
							</DetailListItem>)}
					</DetailList>)}

				{!singleAccount && (<DetailList className={styles.details}>
						<DetailListItem label={messages.totalBalanceLabel}>
							<FormattedNumber value={props.routeGroup.balance} style="currency" currency="USD"/>
						</DetailListItem>
					</DetailList>)}

				{extraDetails.length > 0 && (<DetailList className={styles.details}>
						{extraDetails}
					</DetailList>)}
			</div>

			{!singleAccount && (<div className={styles.routeAccounts}>
					<RouteTable group={props.routeGroup} showDecLastName={false} showDisclaimerIds={false} disclaimerIdMap={{}} accountsPerPage={10} expanded/>
				</div>)}
		</Panel>);
};
export default AccountSummary;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Account/AccountSummary/AccountSummary.tsx